import { inject, Injectable, signal } from '@angular/core';
import { APP_CONFIG } from '@okcargo-apps/shared-infrastructure';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { PlatformService } from '../platform';

@Injectable({
  providedIn: 'root',
})
export class FirebaseService {
  private readonly config = inject(APP_CONFIG);
  private readonly platformService = inject(PlatformService);

  private app?: FirebaseApp;

  private readonly _isInitialized = signal(false);
  public isInitialized = this._isInitialized.asReadonly();

  public async initialize(): Promise<void> {
    if (!this.isInitialized() && this.config.firebase) {
      if (!this.platformService.isHybrid && !this.app) {
        this.app = initializeApp(this.config.firebase);
      }

      // await FirebaseAnalytics.setEnabled({ enabled: true });

      this._isInitialized.set(true);
    }
  }
}
